module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('el-button', {
    attrs: {
      "type": "warning",
      "plain": "",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        return _vm.clickEvent('pdf')
      }
    }
  }, [_vm._v("导出PDF")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "plain": "",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        return _vm.clickEvent('word')
      }
    }
  }, [_vm._v("导出word")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-28170d56"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myButton/DownloadFormButton.vue
// module id = 1890
// module chunks = 1